import Table, { SORTER_STRING } from '../components/Table';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { fetch } from '../store/shownDataSlice';
import * as common from './common';




function NewQueriesTable({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const brandFilter = useSelector((state) => state.shownData.brandFilter);
    const data = common.filterByBrand(useSelector((state) => state.shownData.newQueries), brandFilter);
    const sortedData = [...data].sort((a, b) => {
        return a["query_created"] > b["query_created"] ? -1 : 1;
    });

    useEffect(() => {
        dispatch(fetch.newQueries());
    }, []);



    return   (
        <Table
            columnNames={[
                "Päringu kuupäev",
                "Reisi kuupäev",
                "Firma",
                "Sihtkohad",
                "Reisijad",
                "Vahemaa",
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/query/" + row["query_id"])}>{common.prettifyTimestamp(row["query_created"])}</a>),
                (row) => (<p>{common.displayDepart(row)}</p>),
                (row) => (<p>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{row["query_company"] || (<i style={{ color: "#668" }}>{row["query_fullname"]}</i>)}</p>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
                (row) => (<p>{common.displayDistance(row)}</p>),
            ]}
            columnSorters={[
                ({ query_created: a }, { query_created: b }) => (+a) - (+b),
                (a, b) => common.sortDepart(a, b),
                ({ query_company: a }, { query_company: b }) => SORTER_STRING(a, b),
                null,
                null,
                null,
            ]}
            data={sortedData}
        />
    );
}

export default NewQueriesTable;